import { render } from "./AssignValuesToAttributesModal.vue?vue&type=template&id=3deeb280"
import script from "./AssignValuesToAttributesModal.vue?vue&type=script&lang=js"
export * from "./AssignValuesToAttributesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__